import React, { Fragment } from 'react';
import autobind from 'autobind-decorator';
import { inject, observer } from 'mobx-react';

import HFMModal from '../hfm-modal';

import AlbumModalContent from './album-modal-content';

class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError(error) {
		// Update state so the next render will show the fallback UI.
		return { hasError: true };
	}

	componentDidCatch(error, info) {
		// You can also log the error to an error reporting service
		console.log('[ErrorBoundary - AlbumModal]', error, info);
	}

	render() {
		if (this.state.hasError) {

			// You can render any custom fallback UI
			return <h1>Something went wrong.</h1>;
		}

		return <Fragment>{ this.props.children }</Fragment>;
	}
}

@inject('albumsStore')
@observer
class AlbumModal extends React.Component {
	state = {
		modalOpen: false
	}

	render () {
		const {
			album,
			albumsStore,
			wrapperClassName,
			button: LaunchModalButton
		} = this.props;

		return (
			<ErrorBoundary>
				<div className={ wrapperClassName }>
					<HFMModal
						contentLabel="Edit Album"
						isOpen={ albumsStore.albumModalOpen }
					>
						<AlbumModalContent
							album={ album }
							handleCloseModal={ this.handleCloseModal }
						/>
					</HFMModal>

					<LaunchModalButton onClick={ this.handleOpenModal } />
				</div>
			</ErrorBoundary>
		);
	}

	@autobind
	handleOpenModal () {
		this.props.albumsStore.albumModalOpen = true;
	}

	@autobind
	handleCloseModal () {
		const { albumsStore } = this.props;

		albumsStore.removeUnsavedAlbums();
		albumsStore.albumModalOpen = false;
	}
}

export default AlbumModal;
